import {APP_INITIALIZER, Injectable, Injector, NgModule} from '@angular/core';
import {BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {StoreModule} from '@ngrx/store';
import {metaReducers, reducers} from '@core/reducers';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {environment} from '@environments/environment';
import {EffectsModule} from '@ngrx/effects';
import {SharedModule} from '@shared/shared.module';
import {CoreModule} from '@core/core.module';
import {IndicationsModule} from './views/secured/views/modules/indication/indications.module';
import {ConsentUseCaseModule} from './views/secured/views/modules/consent-use-case/consent-use-case.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatDialogModule} from '@angular/material/dialog';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {MatRadioModule} from '@angular/material/radio';
import * as Hammer from 'hammerjs';
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {EnvironmentService} from '@core/environment/environment.service';
import {initializeKeycloak} from './auth/keycloak-auth.init';
import {WizardModule} from './views/secured/views/modules/wizard/wizard.module';
import {SecuredModule} from './views/secured/secured.module';
import {LoginRedirectModule} from './views/public/components/login-redirect/login-redirect.module';
import {A11yModule} from '@angular/cdk/a11y';
import {ApplicationTranslateInitializerFactory} from './config/translation.config';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
    overrides = {
        swipe: {direction: Hammer.DIRECTION_HORIZONTAL},
        pinch: {enable: false},
        rotate: {enable: false},
        pan: {enable: false}
    };
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        CoreModule,
        SharedModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        BrowserModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: translateFactory,
                deps: [HttpClient]
            }
        }),
        KeycloakAngularModule,
        AppRoutingModule,
        IndicationsModule,
        WizardModule,
        SecuredModule,
        LoginRedirectModule,
        ConsentUseCaseModule,
        BrowserAnimationsModule,
        MatDialogModule,
        HammerModule,
        MatRadioModule,
        InfiniteScrollModule,
        EffectsModule.forRoot(),
        StoreModule.forRoot(reducers, {metaReducers}),
        !environment.production ? StoreDevtoolsModule.instrument() : [],
        A11yModule
    ],
    bootstrap: [AppComponent],
    providers: [
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeKeycloak,
            multi: true,
            deps: [KeycloakService, EnvironmentService]
        },
        {
            provide: APP_INITIALIZER,
            useFactory: ApplicationTranslateInitializerFactory,
            multi: true,
            deps: [TranslateService, Injector]
        }
    ]
})
export class AppModule {
}

export function translateFactory(httpClient: HttpClient): any {
    return new TranslateHttpLoader(httpClient);
}
